import { Row, Col, Modal, Image, Form, Input, Select, Skeleton } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useContext, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import { AuthContext } from "../../context/AuthContext";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

const UserFrom = ({ type, path, sectionName, show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [latLong, setlatLong] = useState({ lat: 30.5595, lng: 22.9375 });
  const [location, setLocation] = useState();
  const [mobileNumber, setMobileNumber] = useState({
    mobile_number: "",
    country_code: "",
  });
  const [userAddress, setUserAddress] = useState(null);
  const handleChange = (value, data) => {
    var country_code = data?.dialCode;
    setMobileNumber({
      country_code: country_code,
      mobile_number: value?.slice(data?.dialCode?.length),
    });
  };
  useEffect(() => {
    if (!data) return;
    setlatLong({
      lat: parseFloat(data.latitude),
      lng: parseFloat(data.longitude),
    });
    setLocation(data.location);
    setMobileNumber({
      mobile_number: data?.mobile_number || "",
      country_code: data?.country_code || "",
    });
    form.setFieldsValue({
      ...data,
      mobile: `${data?.country_code || ""}${data?.mobile_number || ""}`,
    });
  }, [data]);

  const onCreate = (values) => {
    setLoading(true);
    const payload = {
      ...values,
      mobile_number: mobileNumber?.mobile_number,
      country_code: mobileNumber?.country_code,
      latitude: latLong.lat ? latLong.lat : null,
      longitude: latLong.lng ? latLong.lng : null,
      location: userAddress ? userAddress : location,
    };

    request({
      url: `${data ? apiPath.editCustomer + "/" + data._id : path}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const validateName = (rule, value) => {
    if (!value) {
      return Promise.reject("Please enter a name");
    } else if (!/^[A-Z][a-zA-Z ]*$/.test(value)) {
      return Promise.reject(
        "Name must start with a capital letter and contain only letters"
      );
    } else {
      return Promise.resolve();
    }
  };

  return (
    <Modal
      width={500}
      open={show}
      title={`${
        data
          ? lang("Update") + " " + sectionName
          : lang("Add") + " " + lang("New") + " " + sectionName
      }`}
      okText={`${data ? lang("Update") : lang("Add")}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ deal_in: "Products" }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              className="mb-1"
              label="Name"
              name="name"
              normalize={(value) => value.trimStart()}
              rules={[
                { required: true, validator: validateName },
                {
                  max: 200,
                  message: "Name should not contain more than 200 characters!",
                },
                {
                  min: 2,
                  message: "Name should contain at least 2 characters!",
                },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter The Name" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              className="mb-1"
              label="Email Address"
              name="email"
              rules={[
                { type: "email", message: "The email is not a valid email!" },
                { required: true, message: "Please enter the email!" },
                {
                  max: 500,
                  message: "Email should not contain more than 500 characters!",
                },
                {
                  min: 5,
                  message: "Email should contain at least 5 characters!",
                },
                {
                  pattern: new RegExp(
                    /^([a-zA-Z0-9._%-]*[a-zA-Z]+[a-zA-Z0-9._%-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/
                  ),
                  message: "Enter a valid email!",
                },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Email Address" />
            </Form.Item>
          </Col>

          <Col span={24} className="flagMobileNumber">
            <Form.Item
              className="mb-1"
              label="Mobile Number"
              name="mobile"
              rules={[
                {
                  required: true,
                  message: "Please enter a mobile number",
                },
                {
                  validator: (_, value) => {
                    const phoneNumber = mobileNumber?.mobile_number || "";
                    // if (!value) {
                    //   return Promise.reject("Please enter a mobile number");
                    // }
                    if (
                      value &&
                      (phoneNumber.length < 8 || phoneNumber.length > 12)
                    ) {
                      return Promise.reject(
                        "Mobile number must be between 8 and 12 digits"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                inputProps={{
                  name: "mobile",
                  required: true,
                  autoFocus: false,
                  placeholder: "Enter Mobile Number",
                }}
                isValid={(value, country) => {
                  if (value.match(/1234/)) {
                    return "Invalid value: " + value + ", " + country.name;
                  } else {
                    return true;
                  }
                }}
                country={"in"} // Set default country to India
                value={
                  mobileNumber.country_code && mobileNumber.mobile_number
                    ? `+${mobileNumber.country_code}${mobileNumber.mobile_number}`
                    : "+91" // Default to +91 if no value
                }
                onChange={handleChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default UserFrom;
